import { ActionsObservable } from 'redux-observable';
import { flatMap, map } from 'rxjs/operators';
import { fetchJSON$ } from '../api';
import { Action, State } from '../store';
import { actions, actionTypes } from './redux';

const { fetchStateSuccess } = actions;

const fetchState$ = (name: string) =>
    fetchJSON$(`/states/${name}`, {}, 'GET')
        .pipe(map((data: State) => data));

export const fetchStateEpic$ = (action$: ActionsObservable<Action<string>>) =>
    action$
        .ofType(actionTypes.FETCH_STATE_REQUEST)
        .pipe(
            flatMap(({ payload }) => fetchState$(payload)),
            map(d => fetchStateSuccess(d))
        );


// WEBPACK FOOTER //
// ./src/states/epics.ts